export const optionsDescrizioneFarmaco = [
    { value: '', label: 'Da definire', disabled: true},
    { value: '386906001', label: 'Capecitabina'},
    { value: '702804006', label: 'Regorafenib'},
    { value: '764195007', label: 'Lonsurf/Tas 102'},
];
